export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/online_coding_lessons.fd5114f.svg";